export default __webpack_public_path__ + "assets/front/scss/affichage-mosaic.e5ddc3d682f2fb2eed222c83bd23def3.css";